import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "patientSearchContainer" }
const _hoisted_2 = { class: "searchInputWrapper" }
const _hoisted_3 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_4 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  key: 1,
  class: "noResultsMessage"
}
const _hoisted_8 = {
  key: 0,
  class: "selectedPatientCard mt-3 elevation-1"
}
const _hoisted_9 = { class: "patientCardHeader" }
const _hoisted_10 = { class: "flex justify-between items-center" }
const _hoisted_11 = { class: "flex items-center flex-1" }
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "selectedPatientName" }
const _hoisted_14 = { class: "patientDetailsCompact" }
const _hoisted_15 = {
  key: 0,
  class: "detailItem"
}
const _hoisted_16 = {
  key: 1,
  class: "detailItem"
}
const _hoisted_17 = {
  key: 2,
  class: "detailItem"
}
const _hoisted_18 = {
  key: 3,
  class: "detailItem"
}
const _hoisted_19 = { class: "patientCardBody" }
const _hoisted_20 = { class: "weeklyAppointmentsSection" }
const _hoisted_21 = { class: "sectionHeader" }
const _hoisted_22 = { class: "patientStatsGrid" }
const _hoisted_23 = { class: "patientStatsHeader" }
const _hoisted_24 = {
  key: 0,
  class: "disciplineCountsList"
}
const _hoisted_25 = {
  key: 1,
  class: "emptyStatsText"
}
const _hoisted_26 = {
  key: 0,
  class: "futureVisitsSection"
}
const _hoisted_27 = { class: "sectionHeader" }
const _hoisted_28 = { class: "futureVisitsList" }
const _hoisted_29 = { class: "futureVisitDate" }
const _hoisted_30 = { class: "futureVisitMeta" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  key: 0,
  class: "futureVisitsMore"
}
const _hoisted_35 = {
  key: 1,
  class: "insuranceSection"
}
const _hoisted_36 = { class: "sectionHeader" }
const _hoisted_37 = { class: "insuranceDetailsCompact" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  key: 2,
  class: "flagsSection"
}
const _hoisted_44 = { class: "sectionHeader" }
const _hoisted_45 = { class: "flagsDetailList" }
const _hoisted_46 = {
  key: 0,
  class: "alertPatientName"
}
const _hoisted_47 = { class: "alertFlagsList" }
const _hoisted_48 = {
  key: 0,
  class: "alertFlagDescription"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "searchTitle my-2" }, "Patient Finder", -1)),
    _cache[20] || (_cache[20] = _createElementVNode("p", { class: "searchSubtitle mb-3" }, "Search patient by Name, Date of Birth, Phone number, or Chart ID", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.searchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        label: "Search Patient",
        placeholder: "Type patient name, phone, DOB, or chart ID",
        variant: "outlined",
        density: "compact",
        clearable: "",
        loading: _ctx.isSearching,
        onInput: _ctx.onSearchInput,
        onKeydown: _withKeys(_ctx.clearSelection, ["escape"]),
        class: "patientSearchInput"
      }, null, 8, ["modelValue", "loading", "onInput", "onKeydown"]),
      (_ctx.patients.length > 0)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 0,
            class: "patientsList elevation-1"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patients, (patient) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: patient.uuid,
                  onClick: ($event: any) => (_ctx.selectPatient(patient)),
                  class: "patientItem"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      size: "40",
                      class: "mr-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: patient.avatar_url,
                          alt: patient.name
                        }, {
                          placeholder: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-account-circle", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["src", "alt"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "patientName" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(patient.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle, { class: "patientInfo" }, {
                      default: _withCtx(() => [
                        (patient.chart_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Chart ID: " + _toDisplayString(patient.chart_id), 1))
                          : _createCommentVNode("", true),
                        (patient.phone)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Phone: " + _toDisplayString(patient.phone), 1))
                          : _createCommentVNode("", true),
                        (patient.date_of_birth)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "DOB: " + _toDisplayString(patient.date_of_birth), 1))
                          : _createCommentVNode("", true),
                        (patient.email)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Email: " + _toDisplayString(patient.email), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", {
                      class: _normalizeClass(["weeklyAppointmentsCompact", { isEmpty: _ctx.thisWeekPatientAppointmentTotal(patient) === 0 }])
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-calendar-week", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.patientAppointmentSummary(patient)), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.hasSearched && _ctx.patients.length === 0 && !_ctx.isSearching)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_v_icon, { color: "#999" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-account-search", -1)
              ]))]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "No patients found matching your search", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectedPatient)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_avatar, {
                  size: "48",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.selectedPatient.avatar_url,
                      alt: _ctx.selectedPatient.name
                    }, {
                      placeholder: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "48" }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-account-circle", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["src", "alt"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.selectedPatient.name), 1),
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.selectedPatient.chart_id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "ID: " + _toDisplayString(_ctx.selectedPatient.chart_id), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPatient.date_of_birth)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "DOB: " + _toDisplayString(_ctx.selectedPatient.date_of_birth), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPatient.phone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.selectedPatient.phone), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPatient.email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.selectedPatient.email), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode(_component_v_btn, {
                icon: "",
                size: "x-small",
                onClick: _ctx.clearSelection,
                class: "closeBtn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_icon, {
                  size: "small",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-chart-box", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "sectionTitle" }, "Patient Appointments by Discipline", -1))
              ]),
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientAppointmentPeriods(_ctx.selectedPatient), (period) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: period.key,
                    class: _normalizeClass(["patientStatsPeriod", { isEmpty: period.total === 0 }])
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", null, _toDisplayString(period.label), 1),
                      _createElementVNode("strong", null, _toDisplayString(period.total), 1)
                    ]),
                    (period.disciplines.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(period.disciplines, (discipline) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: `${period.key}-${discipline.discipline}`,
                              class: "disciplineCountChip"
                            }, _toDisplayString(discipline.discipline) + ": " + _toDisplayString(discipline.appointments_count), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, "No patient appointments"))
                  ], 2))
                }), 128))
              ])
            ]),
            ((_ctx.selectedPatient.future_visits || []).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-calendar-clock", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "sectionTitle" }, "Upcoming Visits", -1))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPatient.future_visits, (visit) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: visit.uuid,
                        class: "futureVisitItem"
                      }, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatFutureVisitDate(visit)), 1),
                        _createElementVNode("div", _hoisted_30, [
                          (visit.doctor)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(visit.doctor), 1))
                            : _createCommentVNode("", true),
                          (visit.location)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(visit.location), 1))
                            : _createCommentVNode("", true),
                          (visit.procedure)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(visit.procedure), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    ((_ctx.selectedPatient.future_visits_remaining_count || 0) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.futureVisitsRemainingText(_ctx.selectedPatient)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedPatient.insurance && (_ctx.selectedPatient.insurance.payer || _ctx.selectedPatient.insurance.plan_name || _ctx.selectedPatient.insurance.member_id || _ctx.selectedPatient.email))
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-shield-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sectionTitle" }, "Insurance", -1))
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    (_ctx.selectedPatient.insurance.payer || _ctx.selectedPatient.insurance.plan_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          (_ctx.selectedPatient.insurance.payer)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.selectedPatient.insurance.payer), 1))
                            : _createCommentVNode("", true),
                          (_ctx.selectedPatient.insurance.plan_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, " - " + _toDisplayString(_ctx.selectedPatient.insurance.plan_name), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPatient.insurance.member_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Member ID: " + _toDisplayString(_ctx.selectedPatient.insurance.member_id), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPatient.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Email: " + _toDisplayString(_ctx.selectedPatient.email), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.selectedPatient.flags || []).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("mdi-flag", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "sectionTitle" }, "Flags", -1))
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPatient.flags, (flag) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: flag.id,
                        class: "flagDetailItem",
                        style: _normalizeStyle(_ctx.getFlagBorderStyle(flag))
                      }, [
                        _createElementVNode("span", {
                          class: "flagDetailLabel",
                          style: _normalizeStyle(_ctx.getFlagStyle(flag))
                        }, _toDisplayString(flag.message), 5),
                        (flag.description)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "flagDetailDescription",
                              style: _normalizeStyle(_ctx.getFlagBorderStyle(flag))
                            }, _toDisplayString(flag.description), 5))
                          : _createCommentVNode("", true)
                      ], 4))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showAlertDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAlertDialog) = $event)),
      persistent: "",
      "max-width": "520"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "alertDialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "alertDialogTitle" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "#d94554",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createTextVNode(" Patient Alert ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.pendingPatient)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.pendingPatient.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertFlags, (flag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `alert-flag-${flag.id}`,
                      class: "alertFlagItem",
                      style: _normalizeStyle(_ctx.getFlagBorderStyle(flag))
                    }, [
                      _createElementVNode("span", {
                        class: "alertFlagLabel",
                        style: _normalizeStyle(_ctx.getFlagStyle(flag))
                      }, _toDisplayString(flag.message), 5),
                      (flag.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(flag.description), 1))
                        : _createCommentVNode("", true)
                    ], 4))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "alertDialogActions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  onClick: _ctx.confirmAlertFlags
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" Close and Continue ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}